import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';

import {
  attributeOptions,
  hazardAttrs,
  themeGroupings,
} from '../../Utilities/Helpers';

import './Options.scss';

export default function Options({
  hazardOptions,
  mode,
  theme,
  setEventNarratives,
  handleOptionsChange,
}) {
  const [themeAttr, setThemeAttr] = useState(() => {
    let attrs = {};
    Object.keys(themeGroupings).forEach((themeName) => {
      attrs[themeName] = themeGroupings[themeName][0];
    });
    return attrs;
  });

  const handleDamageTypeChange = (event) => {
    handleOptionsChange(
      [hazardOptions[0], event.target.value],
      'hazardOptions'
    );
    setEventNarratives([]);
  };

  const handleThemeSelection = (event) => {
    let newOpts = [
      [event.target.value, 'theme'],
      [1, 'tab'],
    ];

    if (hazardAttrs.includes(themeAttr[event.target.value])) {
      newOpts.push([
        [themeAttr[event.target.value], hazardOptions[1]],
        'hazardOptions',
      ]);
      newOpts.push([false, 'mode']);
    } else {
      newOpts.push([themeAttr[event.target.value], 'climateOption']);
      newOpts.push([true, 'mode']);
    }

    setEventNarratives([]);
    handleOptionsChange(newOpts);
  };

  const handleThemeAttrSelection = (event) => {
    let newOpts = [[1, 'tab']];

    if (hazardAttrs.includes(event.target.value)) {
      newOpts.push([false, 'mode']);
      newOpts.push([[event.target.value, hazardOptions[1]], 'hazardOptions']);
    } else {
      newOpts.push([event.target.value, 'climateOption']);
      newOpts.push([true, 'mode']);
    }

    setEventNarratives([]);
    setThemeAttr({
      ...themeAttr,
      [theme]: event.target.value,
    });
    handleOptionsChange(newOpts);
  };

  const renderAttributes = (themeName) => {
    let climateItems = [];
    let hazardItems = [];

    themeGroupings[themeName].forEach((attribute) => {
      if (hazardAttrs.includes(attribute)) {
        hazardItems.push(
          <MenuItem key={attribute} value={attribute}>
            {attribute}
          </MenuItem>
        );
      } else {
        climateItems.push(
          <MenuItem key={attribute} value={attribute}>
            {attributeOptions[attribute]['name']}
          </MenuItem>
        );
      }
    });

    return (
      <FormControl>
        <InputLabel>Hazards</InputLabel>
        <Select value={themeAttr[theme]} onChange={handleThemeAttrSelection}>
          {climateItems.length > 0 && (
            <ListSubheader>Climate Metrics and Projections</ListSubheader>
          )}
          {climateItems.length > 0 && climateItems}
          {hazardItems.length > 0 && (
            <ListSubheader>Hazard Types</ListSubheader>
          )}
          {hazardItems.length > 0 && hazardItems}
        </Select>
      </FormControl>
    );
  };

  const renderThemes = () => {
    return Object.keys(themeGroupings).map((themeName) => {
      return (
        <MenuItem key={themeName} value={themeName}>
          {themeName}
        </MenuItem>
      );
    });
  };

  return (
    <div id='opts' className='card'>
      <Typography component='h1' variant='h5' id='title'>
        Selection Panel
      </Typography>
      <FormControl>
        <InputLabel>Themes</InputLabel>
        <Select value={theme} onChange={handleThemeSelection}>
          {renderThemes()}
        </Select>
      </FormControl>

      {theme && renderAttributes(theme)}

      {!mode && (
        <FormControl>
          <InputLabel>Impacts</InputLabel>
          <Select value={hazardOptions[1]} onChange={handleDamageTypeChange}>
            <MenuItem value='count'>Total Reported Episodes</MenuItem>
            <MenuItem value='damageCrops'>Reported Crop Damage</MenuItem>
            <MenuItem value='damageProperty'>Reported Property Damage</MenuItem>
            <MenuItem value='deaths'>Total Reported Deaths</MenuItem>
            <MenuItem value='injuries'>Total Reported Injuries</MenuItem>
          </Select>
        </FormControl>
      )}
    </div>
  );
}

Options.propTypes = {
  hazardOptions: PropTypes.array,
  mode: PropTypes.bool,
  theme: PropTypes.string,
  setEventNarratives: PropTypes.func,
  handleOptionsChange: PropTypes.func,
};
